import getTypeStyling from 'helpers/getTypeStyling';
import React from 'react';
import styled, { css } from 'styled-components';
import { BreakPointsType } from 'variables';

const Grid = styled.div<{
    columns: BreakPointsType<number> | number;
    gap: number;
    fullWidth: boolean;
    alignment: 'left' | 'center' | 'right';
}>`
    display: grid;

    ${({ columns, fullWidth }) =>
        getTypeStyling(
            (resolvedColumns: number) => css`
                grid-template-columns: repeat(${resolvedColumns}, ${fullWidth ? '1fr' : 'auto'});
            `
        )(columns)}

    ${({ gap }) =>
        css`
            gap: ${gap}px;
        `}

    ${({ alignment, fullWidth }) =>
        !fullWidth &&
        css`
            justify-content: ${alignment};
        `}
`;

export default function CMSGrid({ columns, fullWidth, alignment, gap = 8, children, ...restProps }) {
    return (
        <Grid columns={columns} fullWidth={fullWidth} alignment={alignment} gap={gap} {...restProps}>
            {children}
        </Grid>
    );
}
